import type { RoomPopupStateType } from './types';

export const getRoomPopup = (state): RoomPopupStateType => state.roomPopup;

export const getRoomPopupIsOpened = (state) => getRoomPopup(state).isOpened;
export const getRoomPopupPackageId = (state) => getRoomPopup(state).packageId;
